import React, { Component } from "react";
import logo from "../img/logo-white.svg";

const Footer = () => (
  <footer>
    <div className="container">
      <div className="c-footer--wrapper">
        <img alt="limenius logo" width="107" height="60" src={logo} />
        <div className="c-footer--social">
          <a
            className="o-social c-github a-hover-flood"
            href="https://github.com/Limenius"
          >
            <i className="o-social--logo" aria-hidden="true" />
            <span className="o-social--text">Our Github</span>
          </a>
          <a
            className="o-social c-twitter a-hover-flood"
            href="https://twitter.com/limenius"
          >
            <i className="o-social--logo" aria-hidden="true" />
            <span className="o-social--text">Our Twitter</span>
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/organisms/Footer.js